"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssetProperties = exports.default = exports.basicAssetProperties = void 0;
var getAssetProperties = exports.getAssetProperties = function getAssetProperties(_ref) {
  var asset = _ref.asset;
  return {
    organizationId: asset.organization.id,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    name: asset.name,
    type: asset.type,
    originalFormat: asset.originalFormat,
    originalFormatVersion: asset.originalFormatVersion
  };
};
var basicAssetProperties = exports.basicAssetProperties = ['organizationId', 'groupId', 'assetId', 'version', 'name', 'type', 'originalFormat', 'originalFormatVersion'];
var _default = exports.default = {
  API_REQUEST_PANEL_SERVER_SELECTION_CHANGED: {
    name: 'API request panel server selection changed',
    required: [].concat(basicAssetProperties, ['serverType'])
  },
  API_REQUEST_PANEL_FIREWALL_TOGGLE_CLICKED: {
    name: 'API request panel firewall toggle clicked',
    required: [].concat(basicAssetProperties, ['firewallToggleActivated'])
  },
  API_REQUEST_PANEL_REQUEST_MADE: {
    name: 'API Console request made',
    required: [].concat(basicAssetProperties, ['serverType', 'isExternalDomain', 'isUsingAPIConsoleProxy'])
  }
};
//# sourceMappingURL=analytics.js.map